import { defineComponent as _defineComponent } from 'vue'
import { BlogPost } from "JS/types/Blog";


export default /*#__PURE__*/_defineComponent({
  __name: 'ArticleCard',
  props: {
    post: null
  },
  setup(__props: any) {

const props = __props as {
	post: BlogPost;
}



function getPostDate(date: string) {
	return new Date(date).toLocaleDateString("en-US", {
		month: "long",
		day: "numeric",
		year: "numeric",
	});
}

return { __sfc: true,props, getPostDate }
}

})